export class ActivacionCargueI{
  id: BigInteger;
  idFte: BigInteger;
  idPeriodo: BigInteger;
  idEstinf: BigInteger;
  fecha: String;
  tipo: String;
  usuario: String;
  observacion: String;
  errorSCT: Boolean;
  errorSV: Boolean;
  errorNC: Boolean;
}
